import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllSubCharacters from "../../Components/Admin/AdminAllSubCharacters";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllSubCharactersPage = () => {
  return (
    <AdminAllSubCharacters />
  );
};

export default AdminAllSubCharactersPage;
